import type { ReportComponent } from '@/types/reports';
import { PARTNER_NONE } from '@/pages/reports/new/constants';

export type ReportFinalizeTarget = 'basic' | 'components';

export interface ReportFinalizeValidation {
  ok: boolean;
  titleError: string;
  editionError: string;
  partnerError: string;
  langError: string;
  componentsError: string;
  target: ReportFinalizeTarget | null;
}

interface ValidateReportFinalizeInput {
  title: string;
  edition: string;
  partnerId: string;
  lang?: string;
  components?: ReportComponent[];
}

export function validateReportFinalize({
  title,
  edition,
  partnerId,
  lang,
}: ValidateReportFinalizeInput): ReportFinalizeValidation {
  const titleError = title.trim() ? '' : 'Título é obrigatório';
  const editionError = edition.trim() ? '' : 'Número da edição é obrigatório';
  const partnerError =
    partnerId && partnerId !== PARTNER_NONE ? '' : 'Marca é obrigatória';
  const langError = !lang || lang === 'pt' || lang === 'es' ? '' : 'Idioma é obrigatório';
  const componentsError = '';

  let target: ReportFinalizeTarget | null = null;
  if (titleError || editionError || partnerError || langError) {
    target = 'basic';
  }

  return {
    ok: !titleError && !editionError && !partnerError && !langError,
    titleError,
    editionError,
    partnerError,
    langError,
    componentsError,
    target,
  };
}
